import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';

import { StateService } from '../services/state/state.service';

@Injectable({
  providedIn: 'root',
})
export class RoleSelectionGuard implements CanActivate, CanActivateChild {
  constructor(
    private readonly stateService: StateService,
    private readonly router: Router
  ) {}

  public canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkRole(state.url);
  }

  public canActivateChild(_childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkRole(state.url);
  }

  private checkRole(url: string): boolean {
    const isAuthenticated = this.stateService.isUserLoggedIn();

    if (!isAuthenticated) {
      return true;
    }

    const user = this.stateService.getCurrentUser();
    const hasAvailableRoles = (user?.roles?.length ?? 0) > 0;
    const hasSelectedRole = (this.stateService.selectedRole() ?? '').trim().length > 0;

    if (hasAvailableRoles && hasSelectedRole) {
      return true;
    }

    void this.router.navigate(['/login/role'], {
      queryParams: { redirect: url },
    });

    return false;
  }
}
